import React from 'react'
import Header from '../Components/Header/İndex'
import '../../App.css'
import Generateİmageİnput from '../GenerateImagePage/Generateİmageİnput'
const HomePage = () => {
  return (
    <div className='homeContainer'>
      <Header />
      <Generateİmageİnput />
    </div>
  )
}

export default HomePage